module.exports = __webpack_public_path__ + "img/ico225.b302647b.svg";